export default __webpack_public_path__ + "static/media/icon-delete.92eb71f3.svg";